/* eslint-disable import/prefer-default-export */

import { startOfToday, endOfToday } from "date-fns";

const dayInMs = 24 * 60 * 60 * 1000;

export const earliestDate = () =>
  new Date(startOfToday().getTime() - 40 * dayInMs);

export const allowedDateRange = val => {
  const date = new Date(val);

  return date >= earliestDate() && date <= endOfToday();
};
